import React, { useState } from 'react'
import { HiArrowSmUp, HiArrowSmDown } from 'react-icons/hi';
import { TableActionItem } from './SmashTableAction';


export interface TableHeaders {
    label: string;
    type?: 'date' | 'bytes';
    accessor: string;
    sortable: boolean;
    sortbyOrder?: "desc" | "asc";
}

interface TableHeadersProps {
    columns: TableHeaders[];
    handleSorting: (accessor: string, sortOrder: "desc" | "asc") => void;
    actions?: TableActionItem[]
}

const SmashTableHead = (props: TableHeadersProps) => {
    const [sortField, setSortField] = useState("");
    const [order, setOrder] = useState("asc");

    const handleSortingChange = (accessor: string, sortable: boolean) => {

        if (sortable) {
            const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
            setSortField(accessor as string);
            setOrder(sortOrder);
            props.handleSorting(accessor as any, sortOrder);
        }
    }

    return (
        <thead className="d-none d-lg-table-header-group">
            <tr >
                {props.columns.map(({ label, accessor, sortable, sortbyOrder }, idx) => {
                    const cl = sortable ? sortbyOrder === "asc" || sortField === accessor && order === "asc"
                        ? <HiArrowSmUp /> : sortbyOrder === "desc" || sortField === accessor && order === "desc"
                            ? <HiArrowSmDown /> : "" : "";

                    return (
                        <th key={idx} onClick={() => handleSortingChange(accessor as string, sortable)}>{cl} {label}</th>
                    )
                })}
                {props.actions?.length && <th key="actionsHead">Actions</th>}
            </tr>
        </thead>
    )
}

export default SmashTableHead